import { TipoGatilho } from "../alerta-gatilho/model/gatilho/tipo-gatilho.enum";
import { AlertaAbstract } from "./alerta-abstract.model";

export class Alerta extends AlertaAbstract {
  
  // FIXME essa lista precisa vir direto da declaração do TipoGatilho
  // , caso um novo tipo de gatilho seja adicionado esta classe vai
  // ficar defasada.
  gatilhos: string[] = [
    TipoGatilho.DIAS_PROX_VENCIMENTO,
    TipoGatilho.QUANT_MINIMA_ESTOQUE,
    TipoGatilho.QUANT_MINIMA_INVENTARIO
  ];
  
  getAlertaDescricao() {
    return null;
  }

  getGatilhos(): string[] {
    return this.gatilhos;
  } 

}